import type { PcfSettingsDto } from '../pipeex/pcfSettingsClient';

type RestPcfSettingsDto = {
  advancedSettings?: string;
  allTags?: string;
  bomParameters?: string;
  isoParameters?: string;
  validationMap?: string;
  settingsType: number;
};

export type GrpcSettingsPayload = {
  advancedSettings: string;
  allTags: string;
  bomParameters: string;
  isoParameters: string;
  validationMap: string;
  settingsType: 0 | 1;
};

export function mapToGrpcPcfSettings(settings: RestPcfSettingsDto): GrpcSettingsPayload {
  return {
    advancedSettings: settings.advancedSettings || '',
    allTags: settings.allTags || '',
    bomParameters: settings.bomParameters || '',
    isoParameters: settings.isoParameters || '',
    validationMap: settings.validationMap || '',
    settingsType: settings.settingsType === 0 ? 0 : 1,
  };
}

export function mapFromGrpcPcfSettings(settings: RestPcfSettingsDto): PcfSettingsDto {
  return mapToGrpcPcfSettings(settings);
}
